import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XanoCollectionsList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionId: null,
  };

  async componentDidMount() {
    const { projectId, version } = this.props.match.params;
    const { history, actions } = this.props;
    const { uuid } = history.location.state.saveExData;
    if (uuid) {
      await actions.getXanoExternalDb({ projectId, version, dbUuid: uuid });
      await actions.collectionListExternaldbs({ projectId, dbUuid: uuid, version });
    }
  }

  handleFormSubmit = () => {
    const { projectId, version } = this.props.match.params;
    const { history } = this.props;
    const { uuid } = history.location.state.saveExData;
    if (uuid) {
      history.push(`/2.0/data-connector/${version}/v/${projectId}/xano-table-schema/${uuid}`, {
        token: history.location.state.token,
        selectedCollectionId: this.state.selectedCollectionId,
      });
    } else {
      console.error('UUID not found in the Redux store.');
    }
  };

  handleContinueButtonClick = () => {
    const { allColname } = this.props.location.state;
    const { selectedCollectionId } = this.state;
    let currentIndex = allColname.findIndex((item) => item.id === selectedCollectionId);
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < allColname.length) {
      const nextCollectionId = allColname[nextIndex].id;
      this.setState({ selectedCollectionId: nextCollectionId }, () => {
        this.handleFormSubmit();
      });
    }
  };
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  renderCollectionCards = (item, index) => {
    const { collectionList } = this.props.dataConnector;
    const name = item.name;
    const matchingObject =
      collectionList && collectionList.find((obj) => obj.orgCollectionName === name);
    return (
      <span className={`card  ml-4 col-lg-4 d-flex`} key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject ? (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name}
              </h5>
            )}

            {item.fields ? (
              <p>Number of fields: {Object.keys(item.fields).length}</p>
            ) : (
              <p>Number of fields: 0</p>
            )}
            {matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
          </div>
        </div>
      </span>
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { xanoExternalDb, getXanoExternalDbPending } = this.props.dataConnector;
    const { completeData } = xanoExternalDb ? xanoExternalDb : '';
    const { tables } = completeData ? completeData : '';
    if (getXanoExternalDbPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={getXanoExternalDbPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Xano'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {tables &&
              tables.map((item, index) => {
                return this.renderCollectionCards(item, index);
              })}
          </div>
          {tables && tables.length > 0 && (
            <div className="card-footer flex-end">
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            </div>
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoCollectionsList);
